import { StrictMode } from 'react';
import { ThemeProvider } from 'next-themes';
import { createRoot } from 'react-dom/client';

import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';

import { GlobalAlert } from './components/alert-popup.tsx';
import { GlobalModal } from './components/modal.tsx';
import App from './App.tsx';

import './index.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const container = document.createElement('div');
document.body.appendChild(container);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(container).render(
  <>
    <StrictMode>
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
        <QueryClientProvider client={queryClient}>
          <TooltipProvider delayDuration={300}>
            <App />
            <GlobalModal />
            <GlobalAlert />
          </TooltipProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </StrictMode>
    <Toaster />
  </>
);
